import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { isTopicMembershipsBlock, TopicMembershipsBlock } from '../../_blocks/TopicMemberships';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';

export type TopicMembershipsWidget = WidgetShape<[TopicMembershipsBlock], WidgetType.topicMemberships>;

/**
 * topicMemberships Widget in PersonalProfile Page.
 */
export function TopicMembershipsWidget({ blocks, elementType, ...headerProps }: TopicMembershipsWidget) {
  const { t } = useSonTranslation('ConnectedTopics');

  const topicMembershipsBlock = blocks.find(isTopicMembershipsBlock);

  if (topicMembershipsBlock && isEmptyBlock(topicMembershipsBlock)) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.TOPIC} title={t('widgetTitle')}>
      {topicMembershipsBlock && <TopicMembershipsBlock {...topicMembershipsBlock} />}
    </DefaultWidgetWithHeader>
  );
}
